import styled from "@emotion/styled";

export const SearchPagePaginationCapacityReached = () => {
  return <Wrapper>Maximum results displayed. Try narrowing your search.</Wrapper>;
};

const Wrapper = styled.div`
  text-align: center;
  color: ${({ theme }) => theme.colors.text.secondary};
  font-size: ${({ theme }) => theme.fontSizes["paragraph-s"]};
`;
